import { useState } from 'react'
import { Dialog, DialogBackdrop, DialogPanel, DialogTitle, Transition } from '@headlessui/react'
import { ExclamationTriangleIcon, CheckCircleIcon } from '@heroicons/react/24/outline'
import { XMarkIcon } from '@heroicons/react/20/solid'
import { t } from 'i18next'

export function GraphQlResponseNoData({ status, title, message, onClose, className }) {
    const [open, setOpen] = useState(status)

    return (
        <div className={`text-center py-24 bg-gray-50 mt-8 rounded-lg ${className || ''}`}>
            <svg
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                aria-hidden="true"
                className="mx-auto h-12 w-12 text-gray-400"
            >
                <path
                    d="M16.6725 16.6412L21 21M19 11C19 15.4183 15.4183 19 11 19C6.58172 19 3 15.4183 3 11C3 6.58172 6.58172 3 11 3C15.4183 3 19 6.58172 19 11Z"
                    strokeWidth={2}
                    vectorEffect="non-scaling-stroke"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
            <h3 className="mt-2 text-sm font-semibold text-gray-900">{t('No records found!')}.</h3>
            <p className="mt-1 text-sm text-gray-500">
                {t('Please add or modify your search criteria and try again.')}
            </p>
            <div className="mt-6"></div>
        </div>
    )
}
